class SnapPixelAnalytics {
  name = "Pixel";

  constructor({ creds, trackerName }) {
    this.creds = creds;

    this.generateScripts(creds);
  }

  user = {};

  generateScripts(creds) {
    const script = document.createElement("script");
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${creds}');
      fbq('track', 'PageView');

    `;

    document.body.appendChild(script);
  }

  addTransaction(payload = {}) {
    const { id, items, revenue } = payload;

    const ids = items.map((item) => item.id);
    const contents = items.reduce((array, item) => {
      const obj = {};

      obj.id = item.id;
      obj.item_price = item.amount;

      array.push(obj);

      return array;
    }, []);

    fbq("track", "Purchase", {
      content_type: "product",
      content_ids: [...ids],
      contents,
      value: revenue,
      currency: "USD",
      num_items: 1,
    });
  }

  addItem(payload = {}) {
    const { id, name, price } = payload;

    fbq("track", "AddToCart", {
      content_ids: [id],
      content_name: name,
      content_type: "product",
      value: price,
      currency: "USD",
    });
  }

  paymentInfo() {
    fbq("track", "AddPaymentInfo");
  }

  track(payload = {}) {
    const { hitType, eventCategory, eventLabel, eventAction } = payload;

    fbq("track", "Lead", {
      content_name: eventLabel,
    });
  }

  send() {
    // addTransaction already sends pixel analytics
  }

  clear() {
    // no clear method in pixel
  }
}

export default SnapPixelAnalytics;
